import { render, staticRenderFns } from "./PurposesRentingAreasItemAddEditModal.vue?vue&type=template&id=5c047d94&scoped=true&"
import script from "./PurposesRentingAreasItemAddEditModal.vue?vue&type=script&lang=js&"
export * from "./PurposesRentingAreasItemAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c047d94",
  null
  
)

export default component.exports